import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_59: DocMigration = {
  maxSchemaVersion: "0.0.59",
  description: "Allow removal of individual foundation footings per edge",
  apply(json: any) {
    if (json.roomLayouts) {
      for (const layoutId in json.roomLayouts) {
        const roomLayout = json.roomLayouts[layoutId];
        if (roomLayout.interiorFoundationInfo) {
          if (!roomLayout.interiorFoundationInfo.length) {
            delete roomLayout["interiorFoundationInfo"];
            roomLayout["foundationInfo"] = [];
          } else {
            const newFoundationInfo = roomLayout.interiorFoundationInfo.map((fi) => ({
              edgeId: fi.edgeId,
              info: {
                type: "FOUNDATION_INFO",
                footingType: "LINEAR_FOOTING",
              },
            }));
            delete roomLayout["interiorFoundationInfo"];
            roomLayout["foundationInfo"] = newFoundationInfo;
          }
        }
      }
    }

    return json;
  },
};

export default migration_0_0_59;
